import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import {
	fetchUserDetails,
	fetchFavourites,
	fetchReminders,
	fetchUserPackets,
	fetchTvPrograms,
	fetchDevices,
	fetchDvrRecordings,
	fetchNpvrRecordings,
	fetchTvCategory,
	fetchActiveSubscriptionsList,
	fetchGenresList,
	fetchFreeProducts
} from 'store/actions';

const useAppResources = () => {
	const dispatch = useDispatch();
	const isAuth = useSelector((state) => state.auth.isLogged);

	const fetchCommonData = async () => {
		await fetchGenresList(dispatch);
		await fetchTvCategory()(dispatch);
		await fetchTvPrograms({ isAuth })(dispatch);
		await fetchFreeProducts()(dispatch);
	};

	const fetchAuthorizedData = async () => {
		await fetchTvPrograms()(dispatch);
		await fetchActiveSubscriptionsList()(dispatch);
		await fetchUserPackets()(dispatch);
		await fetchFavourites()(dispatch);
		await fetchReminders()(dispatch);
		await fetchUserDetails()(dispatch);
		await fetchDevices()(dispatch);
		await fetchDvrRecordings()(dispatch);
		await fetchNpvrRecordings()(dispatch);
	};

	useEffect(() => {
		fetchCommonData();
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (isAuth) fetchAuthorizedData();
		//eslint-disable-next-line
	}, [isAuth]);
};

export default useAppResources;
